/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditorsectiontitle3Inputs */

const en_menueditorsectiontitle3 = /** @type {(inputs: Menueditorsectiontitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Section title`)
};

const de_menueditorsectiontitle3 = /** @type {(inputs: Menueditorsectiontitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel des Bereichs`)
};

/**
* | output |
* | --- |
* | "Section title" |
*
* @param {Menueditorsectiontitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditorsectiontitle3 = /** @type {((inputs?: Menueditorsectiontitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditorsectiontitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditorsectiontitle3(inputs)
	return de_menueditorsectiontitle3(inputs)
});
export { menueditorsectiontitle3 as "menuEditorSectionTitle" }